import { ChangeEvent, DragEventHandler, useState } from "react";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { useNavigate } from "react-router-dom";
import { SmartFormInterFace, SmartSoftForm, SmartValid } from "soft_digi";
import { TASK_API_URLS } from "../../api/TaskApiUrls";
import { showNotification } from "../../services/notifyService";
import { post } from "../../services/smartApiService";


const SignTest = () => {
    const [data, setData] = useState<File>();
    const [FileUploaded, setFileUploaded] = useState(false);
    const [formData, setFormData] = useState<any>({});
    const navigate = useNavigate();

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files ? e.target.files[0] : null;
        if (selectedFile && selectedFile.size <= 10 * 1024 * 1024) {
            setData(selectedFile);
        } else {
            showNotification(
                "error",
                "File size exceeds 10MB limit. Please select a smaller file"
            );
        }
    };


    const readFileContent = (file: File): Promise<string> => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Content = reader.result as string; // Cast to string
                const content = base64Content.split(",")[1]; // Base64 content
                resolve(content);
            };
            reader.readAsDataURL(file);
        });
    };

    const handleSubmit = async () => {
        // setInput(selectedFile);
        setFileUploaded(true);
        if (data) {
            let pdf_content = await readFileContent(data);
            let _task_fields = {
                redirectUrl:"http://test",
                type:"SINGLE_SIGN",
                dscData:[{
                    FileTemplate:"",
                    signObj:[
                        {
                            sigName: formData.task_sig_name
                        }
                    ]
                }]
            };
            let _data = {
                content: pdf_content,
                task_user_id: formData.task_user_id,
                task_user_name: formData.task_user_name,
                task_fields: JSON.stringify(_task_fields)
            }
            const subscription = post(TASK_API_URLS.INSERT_SIGN_TASK, _data).subscribe(
                (response) => {
                    navigate("/open/digital-sign?token=" + response.data.data);
                }
            );
            return () => {
                subscription.unsubscribe();
            };
        }

    }



    const handleDrop: DragEventHandler<HTMLLabelElement> = (e) => {
        e.preventDefault(); // Prevent the default browser behavior for file drop
        const files = e.dataTransfer.files;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.size <= 2 * 1024 * 1024) {
                // const newInput = { file };
                // console.log(" dragged file " , file)
                setData(file);
            } else {
                alert(`File ${file.name} size exceeds 2MB limit. Please select a smaller file.`);
            }
        }
    };

    //   const handleDrop = (e: DragEvent<HTMLDivElement>): void => {
    //     e.preventDefault();
    //     const files = e.dataTransfer.files;
    //     for (let i = 0; i < files.length; i++) {
    //         const file = files[i];
    //         if (file.size <= 2 * 1024 * 1024) {
    //             const newInput = { file };
    //             setData(newInput);
    //             setResult(true);
    //         } else {
    //             alert(`File ${file.name} size exceeds 2MB limit. Please select a smaller file.`);
    //         }
    //     }
    // };

    const validations = {
        task_user_id: [SmartValid.required("Required")],
        task_user_name: [SmartValid.required("Required")],
        task_sig_name: [SmartValid.required("Required")]
    };

    const fileField = () => {
        return (
            <>
                <div><label className="label">Please select the File :</label></div>              
                <div className="file has-name is-boxed">
                    <label className="file-label" onDragOver={(e) => e.preventDefault()}
                        // onDragOver={handleDragOver}
                        onDrop={handleDrop}>
                        <input className="file-input" type="file" name="resume" onChange={handleFileChange} />
                        <span className="file-cta">
                            <span className="file-icon">
                                <i className="fas fa-upload"></i>
                            </span>
                            <span className="file-label"> Drop the files here or Click to Upload … </span>
                        </span>
                        <span className="file-name">{data && data.name ? data.name : ""} </span>
                    </label>
                </div>
            </>)
    }

    const formElements: SmartFormInterFace.SmartFormElementProps[] = [
        {
            type: "TEXT_BOX",
            width: "6",
            name: "task_user_id",
            element: {
                label: "Employee/User ID",
                classList: ["smart-form-input"],
                placeHolder: "Enter your Employee/User ID",
                leftIcon: "fa-user",
                validations: validations.task_user_id,
            },
        },
        {
            type: "TEXT_BOX",
            width: "6",
            name: "task_user_name",
            element: {
                label: "Employee/User Name",
                classList: ["smart-form-input"],
                placeHolder: "Enter your Employee/User Name",
                leftIcon: "fa-user",
                validations: validations.task_user_id,
            },
        },
        {
            type: "TEXT_BOX",
            width: "6",
            name: "task_sig_name",
            element: {
                label: "Signature Field Name",
                classList: ["smart-form-input"],
                placeHolder: "Enter Signature Name",
                leftIcon: "fa-user",
                validations: validations.task_user_id,
            },
        },
        {
            type: "LABEL",
            width: "6",
            name: "task_file",
            labelFunction: fileField
        },
        {
            type: "BUTTON",
            width: "12",
            name: "",
            class_name: "has-text-right",
            element: {
                label: "Digital Sign",
                classList: ["smart-action-button"],
                onClick: handleSubmit,
            },
        },
    ];

    const handleInputChange = (name: string, value: string) => {
        setFormData((prev: any) => ({ ...prev, [name]: value }));
    };



    const uploadCard = () => {
        return (
            <>
                <div className="sd-pdf-form">
                    <SmartSoftForm
                        formData={formData}
                        setFormData={handleInputChange}
                        elements={formElements}
                    />
                </div>
            </>
        );
    };





    return (
        <>
            <p className="has-text-link is-size-4 mb-4">Digital Sign:</p>
            <div className="columns">
                <div className="column is-12 card">{uploadCard()}</div>
            </div>
        </>

    );
};

export default SignTest;
